"use client";

import { RelatedSection } from "@/components/sections/related";
import { relatedCapabilities } from "@/lib/data/services-crisis-prevention";

export function Related() {
  return (
    <RelatedSection
      eyebrow={relatedCapabilities.eyebrow}
      title={relatedCapabilities.title}
      capabilities={relatedCapabilities.capabilities}
      engines={relatedCapabilities.engines}
      services={relatedCapabilities.services}
      accent={relatedCapabilities.accent}
    />
  );
}
